import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import ArrayUtils from 'PMT/utils/ArrayUtils'
import I18n from 'PMT/i18n/I18n'
import StringUtils from 'PMT/utils/StringUtils'

import { FormGroup, FormControl, ControlLabel, Col } from 'react-bootstrap'

const Item = ({ item, isMainCategory }) => (
  <div
    style={{
      padding: '6px 0',
    }}
  >
    {isMainCategory || !item ? I18n.tr('menu.category.add_item.main_category') : item.name}
  </div>
)

const sort = (list) => {
  return _.sortBy(_.compact(list), ['desc'],
    (item): number => {
      // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
      return StringUtils.toAlphaNum(item.name).toLowerCase()
    }
  )
}

const ItemsList = ({ type, items, restaurantMenu }) => {
  // items is an {id, type}, we wants the real object from the restaurantMenu
  const itemsList = items.map(item => (restaurantMenu.getItem(item)))

  return (
    <FormGroup controlId="formControlsSelectMultiple">
      <Col sm={12}>
        <ControlLabel>{I18n.tr(`order.cart_modifiers.items_list.${type}`)}</ControlLabel>
        <div
          style={{
            minHeight: '50px',
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          {sort(itemsList).map((item) => !item ? null : (
            <Item
              key={item.id}
              item={item}
              isMainCategory={restaurantMenu.rootCategoryId === item.id}
            />
          ))}
        </div>
      </Col>
    </FormGroup>
  )
}

ItemsList.propTypes = {
  itemsList: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}

export default ItemsList
